"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_STORE_KEY = void 0;
exports.SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map